<template>
    <div class="loninContaner" v-if="showColumn">
        <div class="overlay_bg"></div>
        <div class="column-box">

            <div class="column-box__header">
                <span class="column-box__title">请选择您的科目</span>
                <button type="button" class="el-dialog__headerbtn" @click="closeColumn()">
                    <i class="el-dialog__close el-icon el-icon-close"></i>
                </button>
            </div>

            <div class="column-box__body">
                <div class="column-box__content">

                    <div v-for="(item, index) in columnData" :key="index">
                        <p class="p-title">{{ item.title }}</p>
                        <ul>
                            <li @click="setSubject(item.id, items.id)" :class="subjectId == items.id ? 'active' : ''"
                                v-for="(items, idx) in item.public"> {{
        items.title }} </li>
                            <li @click="setSubject(item.id, items.id)" :class="subjectId == items.id ? 'active' : ''"
                                v-for="(items, idx) in item.subject"> {{
        items.title }} </li>
                        </ul>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "ColumnBox",
    props: {
        showColumn: { default: true },
        classId: { default: 0 },
        columnId: { default: 0 },
        subjectId: { default: 0 },
    },
    data() {
        return {
            class_id: this.classId,
            columnData: [],
        };
    },
    watch: {
        // 监听prop的变化，并更新本地数据
        classId: {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal)
                if (newVal != oldVal) {
                    this.class_id = newVal;
                }
                this.getColumnList();
            }
        }
    },
    created() {

    },
    methods: {
        setSubject(column_id, subject_id) {
            sessionStorage.setItem("access-column_id", column_id);
            sessionStorage.setItem("access-subject_id", subject_id);
            let formData = {};
            formData.column_id = column_id;
            formData.subject_id = subject_id;
            this.$emit("setSubject", formData);
        },

        //获取分类
        getColumnList() {
            const that = this;
            console.log(this.classId);
            console.log(this.class_id);
            that.axios.post("/getColumnList", {
                class_id: this.class_id
            }).then((res) => {
                if (res.code == 200) {
                    that.columnData = res.data;
                } else {
                    that.loading = false;
                }
            });
        },

        closeColumn() {
            this.$emit("closeColumn", "子向父组件传值");
        },

    },
};
</script>

<style>
.loninContaner {
    position: relative;
    z-index: 999;
}

.loninContaner .overlay_bg {
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: 0.6;
    filter: alpha(opacity=60);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
}

.loninContaner .column-box {
    width: 920px;
    height: auto;
    background-color: #fff;
    position: fixed;
    z-index: 999;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
    -o-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
    /* display: none; */
    z-index: 999;
    border-radius: 2px;
}

.column-box__header {
    height: 60px;
    line-height: 60px;
    text-align: left;
    padding: 0 30px;
    border-bottom: 1px solid #f0f0f0;
}

.column-box__title {
    font-size: 16px;
    font-weight: 700;
    color: #303133;
    text-align: left;
}

.column-box__body {
    height: 500px;
    overflow-y: auto;
    padding: 0 30px;
    color: #333;
    font-size: 14px;
    word-break: break-all;
}

.column-box__content {
    padding: 20px 0;
    line-height: 1;
}

.column-box__content .p-title {
    padding: 20px 0;
}

.column-box__content li.active,
.column-box__content li:hover {
    color: #ffffff;
    background: #4171f9;
}

.column-box__content li {
    line-height: 16px;
    padding: 8px 20px;
    background: #f0f0f0;
    border-radius: 15px;
    margin: 0 10px 20px 10px;
    cursor: pointer;
    display: inline-block;
}

.el-dialog__headerbtn {
    font-size: 26px;
}
</style>